import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import Cards from 'react-credit-cards';
import axios from './../../../../../services/Api'

import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'

import 'react-credit-cards/es/styles-compiled.css'
import './index.css'

export default function CreditCard() {

    const { register, handleSubmit } = useForm();

    const query = new URLSearchParams(window.location.search)
    const planId = query.get('plan_id');

    // const [plan, setPlan] = useState(null);
    // const [plans, setPlans] = useState([])

    const [number, setNumber] = useState('')
    const [name, setName] = useState('')
    const [expiry, setExpiry] = useState('')
    const [cvc, setCvc] = useState('')
    const [focus, setFocus] = useState('')

    useEffect(() => {
        initIugu()
        getPlan();
        getPlans()
    }, [])

    async function getPlan() {
        try {
            let response = await axios.get('/api/plans/' + planId);
            console.log(response.data)
            // setPlan(response.data);
        } catch (e) {
            console.log(e);
        }
    }

    async function getPlans() {
        try {
            let response = await axios.get('/api/plans');
            // setPlans(response.data);
        } catch (e) {
            console.log(e);
        }
    }

    async function initIugu()
    {

    }

    const save = async formData => {
        let Iugu = window.Iugu;
        setFocus('')

        console.log(Iugu)

        let data = {
            creditCard: formData
        }
    }

    return (
        <div className="CreditCard">
            {/* <Loader show={loading} /> */}
            <Row>
                <Col md={6}>
                    <Cards
                        placeholders={{
                            name: 'Seu nome aqui'
                        }}
                        cvc={cvc}
                        expiry={expiry}
                        focused={focus}
                        name={name}
                        number={number}
                    />

                    <div className="plan">
                        <div className="text-center">
                            <h3>Plano básico</h3>
                            <h4>Mensal</h4>
                            <div className="container-value">
                                <span className="prefix-value">R$</span>
                                <span className="value">250,00</span>
                                <span className="cicle">/mês</span>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col md={6}>
                    <Form method="POST" onSubmit={handleSubmit(save)}>
                        <Form.Group controlId="formBasicEmail">
                            <Form.Label>Numero do cartão</Form.Label>
                            <Form.Control type="text" name="number" placeholder="Digite o numero do cartão" ref={register} onChange={(e) => setNumber(e.target.value)} onFocus={handleFocus} />
                        </Form.Group>

                        <Form.Group controlId="formBasicPassword">
                            <Form.Label>Nome no cartão</Form.Label>
                            <Form.Control type="text" name="name" placeholder="Digite o nome no cartão" ref={register} onChange={(e) => setName(e.target.value)} onFocus={handleFocus} />
                        </Form.Group>

                        <Row>
                            <Col md={6}>
                                <Form.Group controlId="formBasicPassword">
                                    <Form.Label>Vencimento</Form.Label>
                                    <Form.Control type="text" name="expiry" placeholder="Digite o vencimento" ref={register} onChange={(e) => setExpiry(e.target.value)} onFocus={handleFocus} />
                                </Form.Group>
                            </Col>

                            <Col md={6}>
                                <Form.Group controlId="formBasicPassword">
                                    <Form.Label>Código de segurança</Form.Label>
                                    <Form.Control type="text" name="cvc" placeholder="Digite o código de segurança" ref={register} onChange={(e) => setCvc(e.target.value)} onFocus={handleFocus} />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Button variant="primary" type="submit">
                            Salvar
                        </Button>
                    </Form>
                </Col>
            </Row>
        </div>
    )

    function handleFocus(e) {
        setFocus(e.target.name);
    }
}